import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { safeStorage } from '@/lib/safeStorage';
import { es, en } from './resources';

i18n.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en } },
  lng: safeStorage.getItem('verix_lang') || 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
